import {
    GET_VIDEOS,
    GET_VIDEOS_SUCCESS,
    GET_VIDEOS_FAILURE,
    UPDATE_VIDEOS_STATUS,
    UPDATE_VIDEOS_STATUS_SUCCESS,
    UPDATE_VIDEOS_STATUS_FAILURE,
    DELETE_VIDEOS,
    DELETE_VIDEOS_SUCCESS,
    DELETE_VIDEOS_FAILURE,
    ADD_VIDEO,
    ADD_VIDEO_SUCCESS,
    ADD_VIDEO_FAILURE,
    EDIT_VIDEO,
    EDIT_VIDEO_SUCCESS,
    EDIT_VIDEO_FAILURE,
    UPDATE_VIDEO_ORDER_STATUS,
    UPDATE_VIDEO_ORDER_STATUS_SUCCESS,
    UPDATE_VIDEO_ORDER_STATUS_FAILURE
} from "../Constants";

const init = {
    data: {},
    update_data: {},
    delete_data: {},
    add_data: {},
    edit_data: {},
    order_data: {},
};

const VideosReducer = (state = init, action) => {
    switch (action.type) {
        case GET_VIDEOS:
            return { ...state, loading: true };
        case GET_VIDEOS_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_VIDEOS_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case UPDATE_VIDEOS_STATUS:
            return { ...state, table_loading: true };
        case UPDATE_VIDEOS_STATUS_SUCCESS:
            return { ...state, table_loading: false, update_data: action.payload };
        case UPDATE_VIDEOS_STATUS_FAILURE:
            return { ...state, table_loading: false, update_data: action.payload };
        case DELETE_VIDEOS:
            return { ...state, table_loading: true };
        case DELETE_VIDEOS_SUCCESS:
            return { ...state, table_loading: false, delete_data: action.payload };
        case DELETE_VIDEOS_FAILURE:
            return { ...state, table_loading: false, delete_data: action.payload };
        case ADD_VIDEO:
            return { ...state, table_loading: true };
        case ADD_VIDEO_SUCCESS:
            return { ...state, table_loading: false, add_data: action.payload };
        case ADD_VIDEO_FAILURE:
            return { ...state, table_loading: false, add_data: action.payload };
        case EDIT_VIDEO:
            return { ...state, table_loading: true };
        case EDIT_VIDEO_SUCCESS:
            return { ...state, table_loading: false, edit_data: action.payload };
        case EDIT_VIDEO_FAILURE:
            return { ...state, table_loading: false, edit_data: action.payload };
        case UPDATE_VIDEO_ORDER_STATUS:
            return { ...state, table_loading: true };
        case UPDATE_VIDEO_ORDER_STATUS_SUCCESS:
            return { ...state, loading: false, order_data: action.payload };
        case UPDATE_VIDEO_ORDER_STATUS_FAILURE:
            return { ...state, loading: false, order_data: action.payload };
        default:
            return state;
    }
};

export default VideosReducer;